<div class="flex flex-row">
  @if (selectable) {
    <div
      class="px-4 py-4 sm:px-6 flex items-center cursor-pointer hover:bg-surface-hover"
      (click)="selectionChanged()"
    >
      @if (selected) {
        <app-ng-icon class="text-2xl" name="heroCheckCircle"></app-ng-icon>
      } @else {
        <svg
          class="h-6 w-6 text-fg-secondary"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M 21 12 a 9 9 0 1 1 -18 0 a 9 9 0 0 1 18 0 z"
          />
        </svg>
      }
    </div>
  }
  <button
    class="relative block hover:bg-surface-hover w-full py-4 min-w-0 focus:outline-none"
    [ngClass]="selectable ? 'pr-4 sm:pr-6' : 'px-4 sm:px-6'"
    (click)="selectable ? selectionChanged() : edit()"
  >
    <div class="flex text-left justify-between items-center">
      <div class="min-w-0">
        <p class="text-sm font-medium text-fg-primary truncate">
          {{ name }}
          @if (category) {
            <app-category-badge
              [color]="category.color"
              [displayName]="category.displayName"
            ></app-category-badge>
          }
        </p>
        <div class="mt-2 sm:flex gap-2">
          @if (documentDate) {
            <div class="mt-2 flex items-center text-sm text-fg-secondary sm:mt-0">
              <app-ng-icon name="heroCalendar"></app-ng-icon>
              <p>
                <time datetime="2020-01-07">{{ documentDate | date: 'dd.MM.yyy' }}</time>
              </p>
            </div>
          }
          @for (linked of linkedEntities | keyvalue: sortByEntityType; track linked.key) {
            <div class="mt-2 flex items-center text-sm text-fg-secondary sm:mt-0">
              <app-entity-icon [entity]="linked.value.entity"></app-entity-icon>
              <p>
                {{ linked.value.name }}
              </p>
            </div>
          }
          @if ((linkedUsers | keyvalue).length > 0) {
            <div class="mt-2 flex items-center gap-1.5 text-sm text-fg-secondary sm:mt-0">
              <!--            <icon-check-badge-sm class="text-fg-faint dark:text-zinc-500"></icon-check-badge-sm>-->
              @for (linkedUser of linkedUsers | keyvalue; track linkedUser.key; let last = $last) {
                <p [class.font-bold]="!linkedUser.value.accepted">
                  {{ linkedUser.value.displayName }}
                  @if (!last) {
                    <span>, </span>
                  }
                </p>
              }
            </div>
          }
        </div>
      </div>
      <div class="flex gap-4">
        <!--        <div class="text-xs rounded bg-amber-50">-->
        <!--          <div class="p-2">-->
        <!--            <p>1. Dez. 24</p>-->
        <!--            <p>+ 1200.00</p>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="ml-2 flex-shrink-0 flex gap-2 justify-end">
          @if (accounting) {
            <p
              class="px-2 h-6 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300 gap-1 items-center"
            >
              <span>Buchhaltung</span>
              @if (accountingProcessed) {
                <app-ng-icon class="text-sm" name="heroCheckCircleMini"></app-ng-icon>
              }
            </p>
          }
          @if (documentAiState === 'ready' || documentAiState === 'processing') {
            <app-ng-icon
              name="heroSparkles"
              [class.animate-pulse]="documentAiState === 'processing'"
              [class.text-fg-muted]="documentAiState === 'processing'"
              class="text-fg-muted"
            ></app-ng-icon>
          }
        </div>
      </div>
    </div>
  </button>

  @if (!selectable) {
    <app-dropdown-minimal-menu>
      <app-dropdown-button>
        <app-ng-icon
          name="heroEllipsisVerticalSolid"
          class="text-3xl"
          strokeWidth="3"
        ></app-ng-icon>
      </app-dropdown-button>
      <app-dropdown-item (menuClick)="edit()"> Dokument bearbeiten </app-dropdown-item>
      @if (!accountingProcessed && !internalInvoice) {
        <app-dropdown-item (menuClick)="deleteDocument.emit()">
          Dokument löschen
        </app-dropdown-item>
      }
      <app-dropdown-item (menuClick)="downloadDocument.emit()"> Download </app-dropdown-item>
      <app-dropdown-item (menuClick)="restartAi()"> Daten erneut auslesen </app-dropdown-item>
    </app-dropdown-minimal-menu>
  }
</div>
